Vendd.Scripts.load(function () {

    var valEngine;
    var observable;
    var articleId;
    var $wrapper = $('.x-control.x-article-review-form[data-control="form"][data-ajax="true"]'),
        wrapper;

    if ($wrapper.length < 1)
        return;

    wrapper = $wrapper.get(0);

    wrapper.loading = function (loading) {
        if (loading) {
            $wrapper.addClass('x-loading');
        } else {
            $wrapper.removeClass('x-loading');
        }
    };

    wrapper.onSuccess = function (envelope) {
        wrapper.loading(false);
        var data = envelope.message.data;

        var $articleReviewControl = $('.x-control.x-article-reviews[data-type="reviews"]:first');

        if ($articleReviewControl.length == 0)
            throw new Error('Article review control does not exist.');

        if (data) {
            $articleReviewControl.find('.critics.form-show-hide').remove();
            $articleReviewControl.find('.already-reviewed-status').show();
            $articleReviewControl.find('.critics.review-status').show();
        }
    };

    wrapper.onFailure = function (envelope) {
        wrapper.loading(false);

        $('.js-error', $wrapper).show();
    };

    wrapper.submit = function () {
        wrapper.loading(true);
        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Article.Messages.ReviewSubmit(observable));
    };

    $wrapper.on('focusout', '.input-wrapper, .textarea-wrapper', function (e) {
        // Hide errors  
        $('.error-wrapper', $(this.parentElement)).children().hide();
    });


    $(".js-submit-button").on('click', function () {
        wrapper.validate();
        wrapper.submit();
    });

    wrapper.onValidationError = function (envelope) {

        var errors = envelope.message.data.errors;
        //Show only LatestError
        $.each(errors, function (index, error) {
            if (error.Property === 'ReviewTitle') {
                $('.review-title-required', $wrapper).show();
            }
            if (error.Property === 'ReviewDescription') {
                $('.review-description-required', $wrapper).show();
            }
        });

    };

    wrapper.validate = function () {

        var valOptions = {
            ValidationEngine: valEngine,
            valmodel: observable.model,
        };
        Vendd.DataValidation.ValidateModel(valOptions);
    };
    
    observable = Vendd.Article.CreateArticleReviewInfo(parseInt($('input[data-member="ReviewArticleId"]').val()));
    Vendd.Databinding.CreateControlDatabindings(wrapper, observable);
    valEngine = Vendd.Article.CreateArticleReviewInfoValidationModel(observable);
    Vendd.MessageBus.subscribe(Vendd.Article.Messages.ReviewSuccess, wrapper, wrapper.onSuccess);
    Vendd.MessageBus.subscribe(Vendd.Article.Messages.ReviewFailure, wrapper, wrapper.onFailure);
    Vendd.MessageBus.subscribe(Vendd.DataValidation.Messages.ValidationError, wrapper, wrapper.onValidationError);
});

